import './SegmentedControl.css';

/**
 * A real sliding switch (the thumb physically moves to the active option),
 * generalized from the roster's own raid/mythic+ sort toggle to any number
 * of options — used for that same tab switch inside the character detail
 * modal, plus its difficulty and spec selectors.
 */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
  className?: string;
}) {
  const index = Math.max(
    0,
    options.findIndex((option) => option.value === value),
  );

  return (
    <div
      className={`segmented-control ${className ?? ''}`}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      <span
        className="segmented-control-thumb"
        aria-hidden="true"
        style={{
          width: `calc((100% - 8px) / ${options.length})`,
          transform: `translateX(${index * 100}%)`,
        }}
      />
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          className={option.value === value ? 'segmented-control-active' : ''}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
